// src/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "/api", // proxy 설정 되어있으니 /api 로 시작하면 됨
});

// 요청 인터셉터: 매번 sessionStorage에서 토큰 꺼내서 Authorization 설정
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
